import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512} {...props}
    viewBox={'0 0 512 512'}>

        <path   fill="#F72585" d="M512 439V39L256 72 0 39v400l256 33zm-16-14-232 30V87l72-9v151l40-20 40 20V67l80-10zM352 76l48-7v134l-24-12-24 12zM16 57l232 30v368L16 425z" />
    </svg>
)

export default SvgComponent
